module.exports = __webpack_public_path__ + "img/pasted imaaage 0.3fe546c2.png";